import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private mainUserData = new BehaviorSubject<any>(null);
  public data$ = this.mainUserData.asObservable();

  constructor() { }

  public setData(dados: any): void {
    this.mainUserData.next(dados);
  }
}
